exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.refund-btn {\n  margin-right: 10px;\n}\n", ""]);

// exports
